import { Coverage } from '@topdanmark-onlinesolutions/claim-form-types';
import {
    IIsCustomerAllowedToSelectWorkshopInput,
    isCustomerAllowedToSelectWorkshop
} from './isCustomerAllowedToSelectWorkshop';
import { IDateOfLoss, isDateOfLossValid } from './dateOfLossRules';

export interface IIsCustomerClaimCoveredInput {
    isPrivateCustomer: boolean;
    isDriverIntoxicated: boolean;
    policyNumber: string;
    coverages: Coverage[];
    damageSituation?: string; // not all forms have the damagesituation question
    formId: string;
    dateOfLoss: IDateOfLoss;
}

export const isCustomerClaimCovered = (
    claimInput: IIsCustomerClaimCoveredInput,
    workshopInput: IIsCustomerAllowedToSelectWorkshopInput
): boolean => {
    // general rules
    if (!claimInput.isPrivateCustomer) {
        return false;
    }
    if (claimInput.isDriverIntoxicated) {
        return false;
    }
    if (!claimInput.policyNumber || claimInput.policyNumber === 'others') {
        return false;
    }

    // date of loss must not be older than 3 years
    if (!isDateOfLossValid(claimInput.dateOfLoss)) {
        return false;
    }

    // customer must have a policy and the policy must contain a comprehensive coverage (aka 'kasko')
    const comprehensiveCoverage = claimInput.coverages.find((coverage) => coverage.name.match(/kasko/gi));
    if (!comprehensiveCoverage || comprehensiveCoverage.status !== 'IKRAFT') {
        return false;
    }

    // all the rules for workshop selection also apply here
    // (we're never showing the 'you are covered' without also letting the customer select a workshop afterwards)
    if (!isCustomerAllowedToSelectWorkshop(workshopInput, 'cpr')) {
        return false;
    }

    // additional form specific rules
    switch (claimInput.formId) {
        case 'ramt-et-koeretoej-privat':
            if (claimInput.damageSituation === 'noneOfTheAbove') {
                return false;
            }
            break;
        default:
            // apply no additonal rules apart form the general rules
            break;
    }

    return true;
};
